/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/// check if page-collection template exists

if(document.querySelector('section').classList.contains('page_collection')){
      
      document.querySelector("body").classList.add("page-collection-1");
}

/*** Move Wishlist button under Delivery div  **/

if(document.querySelector('body').classList.contains('template-product')){
function placeWishlistButton() {
  const wishlistButton = document.getElementById("shopify-block-c6a5cbdc-afe3-4489-908f-9e01885c1359");
  const accordion = document.getElementById("Sidebar--template--19790961443138__main");
  accordion.insertAdjacentElement("afterend", wishlistButton);
}
//placeWishlistButton();
}


(function() {

// Add custom code below this line

/*Nav-overlay on hover*/
var hoveraddElement = document.querySelector('body');
  document.querySelectorAll(".parent").forEach((event) => {
    event.addEventListener('mouseover', () => {
    hoveraddElement.classList.add('nav-overlay');
  });
  event.addEventListener('mouseout', () => {
    hoveraddElement.classList.remove('nav-overlay');
  });
});

/*Nav-overlay on hover End*/

  /* Mobile Footer Menu Accordion */
  const accordionTitles = document.querySelectorAll(".mobile-accordion");
    accordionTitles.forEach((accordionTitle) => {
      accordionTitle.addEventListener("click", () => {
        if (accordionTitle.classList.contains("active")) {
          accordionTitle.nextElementSibling.style.height = 0;
          accordionTitle.classList.remove("active");
        } else {
          const accordionTitlesWithIsOpen = document.querySelectorAll(".active");
          accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
            accordionTitleWithIsOpen.nextElementSibling.style.height = 0;
            accordionTitleWithIsOpen.classList.remove("active");
          });
          accordionTitle.nextElementSibling.style.height = accordionTitle.nextElementSibling.scrollHeight + 'px';
          accordionTitle.classList.add("active");
        }
      });
    });
  /* Mobile Footer Menu Accordion End*/

      /* support for sorting filters */
      function tm_updateSort(sort_param){
        const currentURL = window.location.href;
        function updateURLParameter(url, param, paramValue) {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set(param, paramValue);
            return `${url.split('?')[0]}?${urlParams.toString()}`;
        }
        const updatedURL = updateURLParameter(currentURL, 'sort_by', sort_param);
        window.location.href = updatedURL;
      }
  
      var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        if(width > 767){  
          window.onload = function (){
          const video_id =  document.getElementById("product-video");
          if(video_id !== null) {
            video_id.click();
          } 
        }
      }

      var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        if(width <= 767){
       window.onload = function () {
          const video_id =  document.querySelector("#slide-1 #product-video");
          if(video_id !== null) {
            video_id.click();
          } 
        }
      }

      /* Location switcher popup */
      var modal = document.querySelector(".modal");
      var js_trigger_desktop = document.querySelector(".js_trigger_desktop");
      var js_trigger_mobile = document.querySelector(".js_trigger_mobile");
      var closeButton = document.querySelector(".close-button");

      function toggleModal(scroll_mode=0) {
        modal.classList.toggle("show-modal");
        if(scroll_mode){
          location_ios_scrolling('.modal-scroll');
        }else{
          location_ios_scroll = 0;
        }
        
      }

      function windowOnClick(event) {
        if (event.target === modal) toggleModal();
      }

      js_trigger_desktop.addEventListener("click", function(){ toggleModal(0)});
      js_trigger_mobile.addEventListener("click",function(){ toggleModal(1)});
      closeButton.addEventListener("click", function(){ toggleModal(0)});
      window.addEventListener("click", windowOnClick);

       var desktop = document.querySelector('.js_trigger_desktop');
       var desktopClose = document.querySelector('.close-button');

          desktop.addEventListener('click', function() {
          var body = document.querySelector('body');
            body.classList.add('location-popup');
          });

          desktopClose.addEventListener('click', function() {
          var body = document.querySelector('body');
            body.classList.remove('location-popup');
          });

          var mobile = document.querySelector('.js_trigger_mobile');
          var mobileClose = document.querySelector('.close-button');

            mobile.addEventListener('click', function() {
            var body = document.querySelector('body');
              body.classList.add('location-popup');
            });

            mobileClose.addEventListener('click', function() {
            var body = document.querySelector('body');
              body.classList.remove('location-popup');
            });

        /* Location switcher popup end */

          /* To move last 3 li to first*/
            const myList = document.getElementById('myList');
            const listItems = Array.from(myList.children);
            const lastThreeItems = listItems.splice(-3);
            myList.prepend(...lastThreeItems);
          /* To move last 3 li to first end*/

          const stickyFooter = document.getElementById('footer_sticky');
          function removeClass() {
              stickyFooter.classList.remove('footer_wrapper');
          }
          stickyFooter.addEventListener('click', removeClass);

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        inputname: this.querySelector('input[name="locale_name"], input[name="country_name"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
     // this.elements.button.addEventListener('click', this.openSelector.bind(this));
     // this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => {
          item.addEventListener('click', this.onItemClick.bind(this))
        }
      );
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      this.elements.inputname.value = event.currentTarget.dataset.cname;
      localStorage.setItem("countryname", this.elements.inputname.value);

      console.log('submitting the localization form');
      if (form) form.submit();

      gtag('event', 'change', {
        'button_name': 'localizationformsend',
      });
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  //custom footer currency switcher
  customElements.define('localization-form', LocalizationForm);

  if(localStorage.getItem("countryname")){
    var countryName = localStorage.getItem("countryname");
    document.getElementById("set_c_name_d").innerText= countryName;
    document.getElementById("set_c_name_m").innerText= countryName;
  }

  /*PDP zoom js*/
  var productzoom = document.querySelector('.product__slides .product__slide');
  var productzoomclose = document.querySelector('.pswp__button');
  if (productzoom) {
    productzoom.addEventListener('click', function() {
    var body = document.querySelector('body');
      body.classList.add('pdp_zoom');
    });
  }

if (productzoomclose) {
    productzoomclose.addEventListener('click', function() {
    var body = document.querySelector('body');
      body.classList.remove('pdp_zoom');
    });
  }
/*PDP zoom js end*/
  const swym_button = document.querySelector('.swym-add-to-wishlist');
  if(swym_button != null){
      swym_button.addEventListener('click', () => { 
      setTimeout(function(){
          document.querySelector(".swym-wishlist-notifications-container .swym-emphasis:nth-child(2)").innerHTML = "Your Wishlist";
      }, 800);  
    }); 
  }


/* used for PDP desktop gallery scroll */
   function scrollToAnchor(selectedAnchor) {
      document.querySelector(selectedAnchor).scrollIntoView({
          behavior: 'smooth'
      });
  }

/* link the LANG buttons to the HEXTOM form */
function customSwitchLang(){
  document.querySelectorAll('.ht-tms-option__text')[1].click()
}
/** video autoplay in product recommendations **/

setTimeout(function(){
  var productRecommendationVideos = document.querySelectorAll(".media-video-listing");
    productRecommendationVideos.forEach((productRecommendationVideo) => {
             productRecommendationVideo.play();
         console.log(productRecommendationVideo);
         console.log("productRecommendationVideo");
      
    });
 }, 1000); 

/** GA event tracking **/
var localization_form = document.querySelector(".shopify-localization-form");
localization_form.addEventListener("change", function(){

    console.log("localization_form"); 
  //let element = document.querySelector('.form-success');
  //if(element != null){
    // gtag('event', 'click', {
    //   'button_name': 'contactformsend',
    // });
  //}

});  

/*nav mega menu hover add border*/

function toggleSliderClass(element, className) {
  element.addEventListener('mouseover', () => {
    element.parentNode.classList.add(className);
  });
  element.addEventListener('mouseout', () => {
    element.parentNode.classList.remove(className);
  });
}

const childElementLeft = document.querySelector('.header__dropdown__inner .left-block');
const childElementRight = document.querySelector('.header__dropdown__inner .right-block');

if (childElementLeft) toggleSliderClass(childElementLeft, 'slider_bar_left');
if (childElementRight) toggleSliderClass(childElementRight, 'slider_bar_right');



const clickShop = document.querySelector('.right-block');
const hideBanner   = document.querySelector('.left-block');
const removeBreakMenusCls = document.querySelectorAll('.active-image');

if (hideBanner != null) {
  clickShop.addEventListener('click', () => {
    clickShop.parentNode.classList.add('active-img-action');
    removeBreakMenusCls.forEach((element) => {
      element.classList.remove('active-image');
    });
  });
}



const mouseOutHeader = document.querySelector('.header__dropdown__wrapper');
if (mouseOutHeader != null) {
  mouseOutHeader.addEventListener('mouseleave', () => {
    console.log('fasdfa');
    clickShop.parentNode.classList.remove('active-img-action'); 
    removeBreakMenusCls.forEach((element) => {
    console.log('aaafasdfa');
      element.classList.add('active-image');
    });
  });
}

// Thumbnail video JS 
 function playVideo() {
    var video = document.querySelector('.video__player');
    var thumbnail = document.getElementById('thumbnail');
    
    // Hide the thumbnail and show the video
    thumbnail.style.display = 'none';
    video.style.display = 'block';
    
    // Find the actual video tag inside the template and play it
    var videoTag = video.querySelector('video');
    if (videoTag) {
      videoTag.play();
    }
  }

  function togglePlayPause() {
    var video = document.querySelector('.video__player');
    
    // Find the actual video tag inside the template
    var videoTag = video.querySelector('video');
    if (videoTag) {
      // Toggle between play and pause
      if (videoTag.paused) {
        videoTag.play();
      } else {
        videoTag.pause();
      }
    }
  }
// Thumbnail video JS 
